import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NbInputModule, NbTooltipModule } from '@nebular/theme';
import { NbDatepickerModule } from '@nebular/theme/components/datepicker/datepicker.module';
import { NgbButtonLabel, NgbModule, NgbRadioGroup } from '@ng-bootstrap/ng-bootstrap';
import { NgWizardModule } from 'dapda-ng-wizard';
import { ClipboardModule, ClipboardService } from 'ngx-clipboard';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxFileDropModule } from 'ngx-file-drop';
import { PostalCodeAutocompleteComponent, PostalCodeAutocompleteModule } from 'postal-code-autocomplete';
import { ErrorFormatter } from '../../shared/formatter/error.formatter';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { CalendarComuService } from '../../shared/services/calendar/calendar-comu.service';
import { FormsService } from '../../shared/services/forms/forms.service';
import { AuthService } from '../../shared/services/security/auth.service';
import { TrackAnalyticsService } from '../../shared/services/track-analytics/track-analytics.service';
import { UserService } from '../../shared/services/user/user.service';
import { DateService } from '../../shared/services/utils/date.service';
import { PhoneService } from '../../shared/services/utils/phone.service';
import { StylesProvider } from '../../shared/services/utils/styles.provider';
import { SharedModule } from '../../shared/shared.module';
import { LeadsComunicationService } from '../leads/leads-comunication.service';
import { AssignmentRulesComunicationService } from '../profile/assignment-rules-comunication.service';
import { AutocompleteModule } from '../shared-component/autocomplete/autocomplete.module';
import { CalendarWrapperModule } from '../shared-component/calendar/calendar.module';
import { DragAndDropModule } from '../shared-component/drag-drop/drag-drop.module';
import { DropdownModule } from '../shared-component/dropdown/dropdown.module';
import { DropDownService } from '../shared-component/dropdown/dropdown.service';
import { FiltersModule } from '../shared-component/filters/filters.module';
import { ArchivedModalComponent } from './archived-modal/archived-modal.component';
import { AssignModalComponent } from './assign-modal/assign-modal.component';
import { CalendarModalComponent } from './calendar-modal/calendar-modal.component';
import { CallModalComponent } from './call-modal/call-modal.component';
import { CloseLeadModalComponent } from './close-lead-modal/close-lead-modal.component';
import { CommentModalComponent } from './comment-modal/comment-modal.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { CreateAssignmentRulesModalComponent } from './create-assignment-rules-modal/create-assignment-rules-modal.component';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { EditAssignmentRulesComponent } from './edit-assignment-rules/edit-assignment-rules.component';
import { EmailModalComponent } from './email-modal/email-modal.component';
import { ImportCsvComponent } from './import-csv/import-csv.component';
import { AssignmentRulesSimulatorComponent } from './lead-form/assignment-rules-simulator/assignment-rules-simulator.component';
import { EditLeadFormComponent } from './lead-form/edit-lead-form/edit-lead-form.component';
import { NewLeadFormComponent } from './lead-form/new-lead-form/new-lead-form.component';
import { ModalsHandlerService } from './modals.handler.service';
import { OnTrackModalComponent } from './on-track-modal/on-track-modal.component';
import { PotencialSellersModalComponent } from './potencial-sellers-modal/potencial-sellers-modal.component';
import { ReminderModalComponent } from './reminder-modal/reminder-modal.component';
import { RevertCloseLeadModalComponent } from './revert-close-lead-modal/revert-close-lead-modal.component';
import { SendEmailComponent } from './send-email/send-email.component';
import { SendWhatsappComponent } from './send-whatsapp/send-whatsapp.component';
import { TransferLeadsModalComponent } from './transfer-leads-modal/transfer-leads-modal.component';
import { ViewHtmlModalComponent } from './view-html-modal/view-html-modal.component';
import { VisitModalComponent } from './visit-modal/visit-modal.component';
import { ExternalFeatureModalComponent } from './external-feature-modal/external-feature-modal.component';
import { SimpleMessageModalComponent } from './simple-message-modal/simple-message-modal.component';
@NgModule({
  declarations: [
    ViewHtmlModalComponent,
    DeleteModalComponent,
    AssignModalComponent,
    TransferLeadsModalComponent,
    SendEmailComponent,
    SendWhatsappComponent,
    NewLeadFormComponent,
    AssignmentRulesSimulatorComponent,
    EditLeadFormComponent,
    OnTrackModalComponent,
    ArchivedModalComponent,
    CalendarModalComponent,
    ReminderModalComponent,
    CloseLeadModalComponent,
    VisitModalComponent,
    CallModalComponent,
    ImportCsvComponent,
    CommentModalComponent,
    EmailModalComponent,
    RevertCloseLeadModalComponent,
    PotencialSellersModalComponent,
    CreateAssignmentRulesModalComponent,
    ConfirmModalComponent,
    EditAssignmentRulesComponent,
    ExternalFeatureModalComponent,
    SimpleMessageModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule.forChild(),
    FiltersModule,
    NgbModule,
    FormsModule,
    NgxDaterangepickerMd,
    NbDatepickerModule,
    NbInputModule,
    NgxFileDropModule,
    ReactiveFormsModule,
    RouterModule,
    AngularEditorModule,
    PipesModule,
    DropdownModule,
    CalendarWrapperModule,
    AutocompleteModule,
    ClipboardModule,
    NbTooltipModule,
    PostalCodeAutocompleteModule,
    NgWizardModule,
    DragAndDropModule,
  ],
  exports: [ViewHtmlModalComponent,
    DeleteModalComponent,
    AssignModalComponent,
    TransferLeadsModalComponent,
    SendEmailComponent,
    SendWhatsappComponent,
    NewLeadFormComponent,
    EditLeadFormComponent,
    OnTrackModalComponent,
    ArchivedModalComponent,
    ReminderModalComponent,
    CalendarModalComponent,
    CloseLeadModalComponent,
    VisitModalComponent,
    CallModalComponent,
    ImportCsvComponent,
    CommentModalComponent,
    EmailModalComponent,
    RevertCloseLeadModalComponent,
    PostalCodeAutocompleteComponent,
    PotencialSellersModalComponent,
    AssignmentRulesSimulatorComponent,
    CreateAssignmentRulesModalComponent,
    ConfirmModalComponent,
    EditAssignmentRulesComponent,
    ExternalFeatureModalComponent,
    SimpleMessageModalComponent,
  ],
  providers: [
    NbDatepickerModule,
    NgbRadioGroup,
    NgbButtonLabel,
    DateService,
    TrackAnalyticsService,
    FormsService,
    CalendarComuService,
    PhoneService,
    ErrorFormatter,
    StylesProvider,
    UserService,
    ClipboardService,
    AssignmentRulesComunicationService,
  ]
})
export class ModalsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ModalsModule,
      providers: [ModalsHandlerService, LeadsComunicationService, CalendarComuService, DropDownService, FormsService, AuthService]
    };
  }
  static forChild(): ModuleWithProviders {
    return {
      ngModule: ModalsModule,
      providers: []
    };
  }
}
